import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ScrollText, Loader2 } from "lucide-react";
import api from "../lib/api";

const ACTION_LABELS = {
  create: "Creación (ingesta)",
  reingest: "Re-ingesta (duplicado)",
  edit: "Edición manual",
  api_key_create: "Clave API creada",
  api_key_revoke: "Clave API revocada",
};

export default function Audit() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/audit", { params: { limit: 200 } })
      .then((r) => setItems(r.data.items))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="audit-page" className="max-w-4xl">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">Auditoría</h1>
      <p className="text-sm text-slate-500 mb-6">Registro cronológico de ingesta, ediciones y gestión de claves.</p>

      {loading ? (
        <div className="flex justify-center py-12" data-testid="audit-loading"><Loader2 className="w-6 h-6 animate-spin text-[#8b5cf6]" /></div>
      ) : items.length === 0 ? (
        <div className="card-glow rounded-lg p-10 text-center" data-testid="audit-empty">
          <ScrollText className="w-7 h-7 text-slate-600 mx-auto mb-3" />
          <p className="text-sm text-slate-400">Sin actividad registrada todavía.</p>
        </div>
      ) : (
        <div className="space-y-2" data-testid="audit-list">
          {items.map((a) => (
            <div key={a.id} className="card-glow rounded-lg p-4" data-testid={`audit-row-${a.id}`}>
              <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
                <span className="text-sm font-medium">{ACTION_LABELS[a.action] || a.action}</span>
                <span className="font-mono2 text-xs text-slate-500">{new Date(a.timestamp).toLocaleString("es-ES")}</span>
              </div>
              <div className="text-xs text-slate-500">
                Actor: <span className="text-slate-300">{a.actor}</span>
                {a.report_id && (
                  <>
                    {" · Informe: "}
                    <Link to={`/informes/${a.report_id}`} className="text-[#8b5cf6] hover:text-[#c084fc] font-mono2" data-testid={`audit-link-${a.id}`}>
                      {a.report_id.slice(-8)}
                    </Link>
                  </>
                )}
              </div>
              {a.note && <div className="text-xs text-slate-600 mt-1">{a.note}</div>}
              {Object.keys(a.changes || {}).length > 0 && (
                <div className="mt-2 space-y-1">
                  {Object.entries(a.changes).map(([field, ch]) => (
                    <div key={field} className="text-xs bg-[#090a0f] border border-[#232838] rounded px-2.5 py-1.5">
                      <span className="font-mono2 text-[#8b5cf6]">{field}</span>
                      <span className="text-slate-600"> · {Array.isArray(ch.old) ? `${ch.old.length} elem.` : String(ch.old ?? "—").slice(0, 60) || "—"}</span>
                      <span className="text-slate-500"> → </span>
                      <span className="text-slate-400">{Array.isArray(ch.new) ? `${ch.new.length} elem.` : String(ch.new ?? "—").slice(0, 60) || "—"}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
